import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../loading.service';
import { SnackService } from '../snack.service';
import { Observable } from 'rxjs';
import { _get } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class NonImmoBaseProjectExecutionInfoControllerRequestService {
  private static BASE_URL = '/subprojects/non-immo-base-project-execution-info';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) =>
    res as NonImmoBaseProjectExecutionInfo;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      NonImmoBaseProjectExecutionInfoControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public nonImmoBaseProjectExecutionInfoForProject(
    baseProjectId: number
  ): Promise<NonImmoBaseProjectExecutionInfo> {
    return this.get(`/${baseProjectId}`, this.deserialize).toPromise();
  }
}

export interface NonImmoBaseProjectExecutionInfo {
  placerNames: string[];
  currentExecutionDate: Date;
}
